import { render, staticRenderFns } from "./recordingh5.vue?vue&type=template&id=703b5ede"
import script from "./recordingh5.vue?vue&type=script&lang=js"
export * from "./recordingh5.vue?vue&type=script&lang=js"
import style0 from "./recordingh5.vue?vue&type=style&index=0&id=703b5ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports